import { isUndNull, isUndNullEmp, getResponse, settings } from '../../helpers/main';
const currentMethod = 'User - class';
const currentDateTimeISO = new Date()?.toISOString();

//#region old code
// export class User {
//     constructor(
//         _id = '',
//         _address = '',
//         _email = '',
//         _password = '',
//         _firstName = '',
//         _lastName = '',
//         _phoneNumber = '',
//         _telegramId = 0,
//         _urlPicture = '',
//         _createdUserId = '',
//         _deletedDate = '',
//         _deletedRemark = '',
//         _deletedUserId = '',
//         _disabledDate = '',
//         _disabledRemark = '',
//         _disabledUserId = '',
//         _urlEmailConfirm = '',
//         _urlPasswordReset = '',
//     ) {
//         this.id = _id;
//         this.address = _address;
//         this.email = _email;
//         this.password = _password;
//         this.firstName = _firstName;
//         this.lastName = _lastName;
//         this.phoneNumber = _phoneNumber;
//         this.telegramId = _telegramId;
//         this.urlPicture = _urlPicture;
//         this.createdUserId = _createdUserId;
//         this.deletedDate = _deletedDate;
//         this.deletedRemark = _deletedRemark;
//         this.deletedUserId = _deletedUserId;
//         this.disabledDate = _disabledDate;
//         this.disabledRemark = _disabledRemark;
//         this.disabledUserId = _disabledUserId;
//         this.urlEmailConfirm = _urlEmailConfirm;
//         this.urlPasswordReset = _urlPasswordReset;
//     }

//     static getClassName = () => {
//         return 'User - class';
//     }

//     static minMaxLength = (upperCase = false) => {
//         if (upperCase) {
//             return {
//                 min: {
//                     Id: 10,
//                     //Address: max,
//                     Email: 50,
//                     Password: 50,
//                     FirstName: 3,
//                     LastName: 3,
//                     PhoneNumber: 7,
//                     //TelegramId: 0,
//                     //UrlPicture: max,
//                     CreatedUserId: 10,
//                     DeletedDate: 10,
//                     DeletedRemark: 5,
//                     DeletedUserId: 10,
//                     DisabledDate: 10,
//                     DisabledRemark: 5,
//                     DisabledUserId: 10,
//                     //UrlEmailConfirm: max,
//                     //UrlPasswordReset: max,
//                     Register: 10,
//                 },
//                 max: {
//                     Id: 450,
//                     //Address: max,
//                     Email: 100,
//                     Password: 256,
//                     FirstName: 100,
//                     LastName: 100,
//                     PhoneNumber: 30,
//                     TelegramId: 0,
//                     //UrlPicture: max,
//                     CreatedUserId: 450,
//                     DeletedDate: 30,
//                     DeletedRemark: 450,
//                     DeletedUserId: 450,
//                     DisabledDate: 30,
//                     DisabledRemark: 450,
//                     DisabledUserId: 450,
//                     //UrlEmailConfirm: max,
//                     //UrlPasswordReset: max,
//                     Register: 30,
//                 },
//             };
//         } else {
//             return {
//                 min: {
//                     id: 10,
//                     //address: max,
//                     email: 50,
//                     password: 50,
//                     firstName: 3,
//                     lastName: 3,
//                     phoneNumber: 7,
//                     //telegramId: 0,
//                     //urlPicture: max,
//                     createdUserId: 10,
//                     deletedDate: 10,
//                     deletedRemark: 5,
//                     deletedUserId: 10,
//                     disabledDate: 10,
//                     disabledRemark: 5,
//                     disabledUserId: 10,
//                     //urlEmailConfirm: max,
//                     //urlPasswordReset: max,
//                     register: 10,
//                 },
//                 max: {
//                     id: 450,
//                     //address: max,
//                     email: 100,
//                     password: 256,
//                     firstName: 100,
//                     lastName: 100,
//                     phoneNumber: 30,
//                     telegramId: 0,
//                     //urlPicture: max,
//                     createdUserId: 450,
//                     deletedDate: 30,
//                     deletedRemark: 450,
//                     deletedUserId: 450,
//                     disabledDate: 30,
//                     disabledRemark: 450,
//                     disabledUserId: 450,
//                     //urlEmailConfirm: max,
//                     //urlPasswordReset: max,
//                     register: 30,
//                 }
//             };
//         }
//     }

//     static class = (obj = {}) => {
//         if (!isUndNullEmp({ data: obj, subMethod: User.getClassName() })?.result) {
//             return new User(
//                 obj.id,
//                 obj.address,
//                 obj.email,
//                 obj.firstName,
//                 obj.lastName,
//                 obj.phoneNumber,
//                 obj.role,
//                 obj.telegramId,
//                 obj.urlPicture,
//                 obj.createdUserId,
//                 obj.deletedDate,
//                 obj.deletedRemark,
//                 obj.deletedUserId,
//                 obj.disabledDate,
//                 obj.disabledRemark,
//                 obj.disabledUserId,
//                 obj.urlEmailConfirm,
//                 obj.urlPasswordReset
//             );
//         } else {
//             return new User();
//         }
//     }
// }
//#endregion old code

export class User {
    constructor(
        _id = '',
        _email = '',
        _password = '',
        _firstName = '',
        _lastName = '',
        _phoneNumber = '',
        _telegramId = 0,
        _urlPicture = '',
        _department = '',
        _position = '',
        _createdUserId = '',
        _deletedDate = currentDateTimeISO,
        _deletedRemark = '',
        _deletedUserId = '',
        _disabledDate = currentDateTimeISO,
        _disabledRemark = '',
        _disabledUserId = '',
        _urlEmailConfirm = '',
        _urlPasswordReset = '',
        _register = currentDateTimeISO,
    ) {
        //#region old code
        // this.id = _id;
        // this.email = _email;
        // this.password = _password;
        // this.firstName = _firstName;
        // this.lastName = _lastName;
        // this.phoneNumber = _phoneNumber;
        // this.telegramId = _telegramId;
        // this.urlPicture = _urlPicture;
        // this.department = _department;
        // this.position = _position;
        // this.createdUserId = _createdUserId;
        // this.deletedDate = _deletedDate;
        // this.deletedRemark = _deletedRemark;
        // this.deletedUserId = _deletedUserId;
        // this.disabledDate = _disabledDate;
        // this.disabledRemark = _disabledRemark;
        // this.disabledUserId = _disabledUserId;
        // this.urlEmailConfirm = _urlEmailConfirm;
        // this.urlPasswordReset = _urlPasswordReset;
        // this.register = _register;
        //#endregion old code
        this.id = isUndNullEmp({ data: _id, subMethod: currentMethod, })?.result ? '' : _id;
        this.email = isUndNullEmp({ data: _email, subMethod: currentMethod, })?.result ? '' : _email;
        this.password = isUndNullEmp({ data: _password, subMethod: currentMethod, })?.result ? '' : _password;
        this.firstName = isUndNullEmp({ data: _firstName, subMethod: currentMethod, })?.result ? '' : _firstName;
        this.lastName = isUndNullEmp({ data: _lastName, subMethod: currentMethod, })?.result ? '' : _lastName;
        this.phoneNumber = isUndNullEmp({ data: _phoneNumber, subMethod: currentMethod, })?.result ? '' : _phoneNumber;
        this.telegramId = isUndNull({ data: _telegramId, subMethod: currentMethod, })?.result ? 0 : _telegramId;
        this.urlPicture = isUndNullEmp({ data: _urlPicture, subMethod: currentMethod, })?.result ? '' : _urlPicture;
        this.department = isUndNullEmp({ data: _department, subMethod: currentMethod, })?.result ? '' : _department;
        this.position = isUndNullEmp({ data: _position, subMethod: currentMethod, })?.result ? '' : _position;
        this.createdUserId = isUndNullEmp({ data: _createdUserId, subMethod: currentMethod, })?.result ? '' : _createdUserId;
        this.deletedDate = isUndNullEmp({ data: _deletedDate, subMethod: currentMethod, })?.result ? '' : _deletedDate;
        this.deletedRemark = isUndNullEmp({ data: _deletedRemark, subMethod: currentMethod, })?.result ? '' : _deletedRemark;
        this.deletedUserId = isUndNullEmp({ data: _deletedUserId, subMethod: currentMethod, })?.result ? '' : _deletedUserId;
        this.disabledDate = isUndNullEmp({ data: _disabledDate, subMethod: currentMethod, })?.result ? '' : _disabledDate;
        this.disabledRemark = isUndNullEmp({ data: _disabledRemark, subMethod: currentMethod, })?.result ? '' : _disabledRemark;
        this.disabledUserId = isUndNullEmp({ data: _disabledUserId, subMethod: currentMethod, })?.result ? '' : _disabledUserId;
        this.urlEmailConfirm = isUndNullEmp({ data: _urlEmailConfirm, subMethod: currentMethod, })?.result ? '' : _urlEmailConfirm;
        this.urlPasswordReset = isUndNullEmp({ data: _urlPasswordReset, subMethod: currentMethod, })?.result ? '' : _urlPasswordReset;
        this.register = _register;
    }

    static getClassName = () => {
        return 'User - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 10,
                    //Address: max,
                    Email: 50,
                    Password: 50,
                    FirstName: 2,
                    LastName: 2,
                    PhoneNumber: 7,
                    //TelegramId: 0,
                    //UrlPicture: max,
                    Department: 4,
                    Position: 3,
                    CreatedUserId: 10,
                    DeletedDate: 10,
                    DeletedRemark: 5,
                    DeletedUserId: 10,
                    DisabledDate: 10,
                    DisabledRemark: 5,
                    DisabledUserId: 10,
                    //UrlEmailConfirm: max,
                    //UrlPasswordReset: max,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    //Address: max,
                    Email: 100,
                    Password: 256,
                    FirstName: 100,
                    LastName: 100,
                    PhoneNumber: 30,
                    TelegramId: 0,
                    //UrlPicture: max,
                    Department: 30,
                    Position: 30,
                    CreatedUserId: 450,
                    DeletedDate: 30,
                    DeletedRemark: 450,
                    DeletedUserId: 450,
                    DisabledDate: 30,
                    DisabledRemark: 450,
                    DisabledUserId: 450,
                    //UrlEmailConfirm: max,
                    //UrlPasswordReset: max,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 10,
                    //address: max,
                    email: 50,
                    password: 50,
                    firstName: 2,
                    lastName: 2,
                    phoneNumber: 7,
                    //telegramId: 0,
                    //urlPicture: max,
                    department: 4,
                    position: 3,
                    createdUserId: 10,
                    deletedDate: 10,
                    deletedRemark: 5,
                    deletedUserId: 10,
                    disabledDate: 10,
                    disabledRemark: 5,
                    disabledUserId: 10,
                    //urlEmailConfirm: max,
                    //urlPasswordReset: max,
                    register: 10,
                },
                max: {
                    id: 450,
                    //address: max,
                    email: 100,
                    password: 256,
                    firstName: 100,
                    lastName: 100,
                    phoneNumber: 30,
                    //telegramId: 0,
                    //urlPicture: max,
                    department: 30,
                    position: 30,
                    createdUserId: 450,
                    deletedDate: 30,
                    deletedRemark: 450,
                    deletedUserId: 450,
                    disabledDate: 30,
                    disabledRemark: 450,
                    disabledUserId: 450,
                    //urlEmailConfirm: max,
                    //urlPasswordReset: max,
                    register: 30,
                }
            };
        }
    }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: User.getClassName() })?.result) {
            if (upperCase) {
                return new User(
                    obj.Id,
                    obj.Email,
                    obj.Password,
                    obj.FirstName,
                    obj.LastName,
                    obj.PhoneNumber,
                    obj.TelegramId,
                    obj.UrlPicture,
                    obj.Department,
                    obj.Position,
                    obj.CreatedUserId,
                    obj.DeletedDate,
                    obj.DeletedRemark,
                    obj.DeletedUserId,
                    obj.DisabledDate,
                    obj.DisabledRemark,
                    obj.DisabledUserId,
                    obj.UrlEmailConfirm,
                    obj.UrlPasswordReset,
                    obj.Register,
                );
            } else {
                return new User(
                    obj.id,
                    obj.email,
                    obj.password,
                    obj.firstName,
                    obj.lastName,
                    obj.phoneNumber,
                    obj.telegramId,
                    obj.urlPicture,
                    obj.department,
                    obj.position,
                    obj.createdUserId,
                    obj.deletedDate,
                    obj.deletedRemark,
                    obj.deletedUserId,
                    obj.disabledDate,
                    obj.disabledRemark,
                    obj.disabledUserId,
                    obj.urlEmailConfirm,
                    obj.urlPasswordReset,
                    obj.register,
                );
            }
        } else {
            return new User();
        }
    }

    static getPictureFullPath = ({ picture = '', subMethod = '' } = {}) => {
        let response = Object?.assign(getResponse(), { noImage: '' });
        const currentMethod = 'User / getPictureFullPath';
        try {
            if (!isUndNullEmp({ data: picture, subMethod: currentMethod })?.result) {
                response.result = `${settings?.backend?.urls?.api}${picture}`
                response.noImage = `${settings?.backend?.urls?.api}${settings?.images?.noImage}`;
            } else {
                response.result = `${settings?.backend?.urls?.api}${settings?.images?.noImage}`;
                response.noImage = `${settings?.backend?.urls?.api}${settings?.images?.noImage}`;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            response.noImage = `${settings?.backend?.urls?.api}${settings?.images?.noImage}`;
        }
        return response;
    }
}